
jQuery.widget("bluaul.TicketList", jQuery.common.vcBaseV4, {
    /// <summary>
    /// This object provides js functions for the Widget.Ticket.TicketList.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 1.12.2025<br />
    /// Copyright ©: EUDT GmbH 2025 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.1.0 - 30.1.2025- AFU                                          *<br />
    /// **********************************************************************<br />
    /// * - extracted from Operation.js                                      *<br />
    /// **********************************************************************<br />
    /// </summary>
    entryList: [],
    fs: { SortId: 0, SortType: "desc", FilterId: 1, StartDate: "", EndDate: "", Blid: -1},
    entry: null,
    allFiltersInitialized: false,
   
    _create: function () {

        // reset everything to default values on create, to ensure a clean state when reusing the widget instance
        this.fs = { SortId: 0, SortType: "desc", FilterId: 1, StartDate: "", EndDate: "", Blid: -1 };
        this.allFiltersInitialized = false;
        this._fetchToken = 0;
        this._openTidPending = false;

        this._createVisual(371);
        this._super();

       

    },
    _initHTML: function () {
        var me = this;
        try {
          
            me._setRoot(".ticket-list");
            if (me.settings.parameter.Simple)  me.myRoot.addClass("simple");
          
            me._buildHtml();
            me._setHeightsAndWidths();

            var param = { "typeid": 3}

            me.getData(param,
                function (result) {
                    if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }
                   
                });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _buildHtml: function () {
        /// <summary>
        /// This function builds the top menu html structure only
        /// </summary>
        var me = this;
        try {

            //init the main html parts
            me.myHtml = { topMenu: {}, subMenu: {}, filterMenu: {}, list: {}};


            //add the top menu
            let obj = me.myHtml.topMenu;
            obj.wrapper = me._setWrapper("div-menu-filter", "").css("overflow", "visible"); // TODO: Discuss overflow hidden hiding date picker
            obj.date = me._setObj("vc-date-filter", "optionbox disabled vc-grid-2col vc-grid-margin-right float-box");
            obj.projectFilterBox = me._setObj("ddl-project-filter-box", "optionbox vc-grid-2col vc-grid-margin-right float-box");
            obj.ddlProjectFilter = me._setObj("ddl-project-filter", "vc-grid-2col");
            obj.userFilterBox = me._setObj("ddl-user-filter-box", "optionbox vc-grid-2col float-box");
            obj.ddlUserFilter = me._setObj("ddl-user-filter", "vc-grid-2col");
            obj.wrapper.append(obj.date, obj.projectFilterBox, obj.userFilterBox);
            me.myRoot.append(obj.wrapper);


            //add the sub menu
            obj = me.myHtml.subMenu;
            obj.wrapper = me._setWrapper("div-main-menu", "sub-menu"); 
            obj.menu = me._setObj("", "float-box");
            obj.btnShowAllMyOpenEntries = me._setObj("", "button-toggle vc-grid-2col").data("filterid", 0).html(me.specific.resources.showAllMyOpenEntries);
            obj.btnShowAllOpenEntries = me._setObj("", "button-toggle button-toggle-active  vc-grid-2col").data("filterid", 1).html(me.specific.resources.showAllOpenEntries);
            obj.btnShowMyWatchlist = me._setObj("", "button-toggle vc-grid-2col").data("filterid", 2).html(me.specific.resources.myWatchlist);
            obj.btnShowAllMyEntries = me._setObj("", "button-toggle vc-grid-2col").data("filterid", 3).html(me.specific.resources.showAllMyEntries);

            obj.btnShowAllEntries = me._setObj("", "button-toggle vc-grid-2col").data("filterid", 4).html(me.specific.resources.showAllEntries);
            obj.btnShowCustomerRequests = me._setObj("", "button-toggle vc-grid-2col").data("filterid", 6).html(me.specific.resources.showCustomerRequests);

            obj.btnNew = me._setObj("div-btn-new", "vc-grid-1col float-box").html(me.specific.resources.new);

            obj.menu.append(obj.btnShowAllMyOpenEntries, obj.btnShowAllOpenEntries, obj.btnShowMyWatchlist, obj.btnShowAllMyEntries, obj.btnShowAllEntries);

            // customer requests button is only shown for staff users, not for customer users
            if (me.specific.isStaff === "true") {
                obj.menu.append(obj.btnShowCustomerRequests);
            }

            obj.menu.append(obj.btnNew);
           
           
            obj.wrapper.append(obj.menu);
            me.myRoot.append(obj.wrapper);

            //add the filter menu
            obj = me.myHtml.filterMenu;
            obj.wrapper = me._setWrapper("", "filter-menu");
            obj.filter = me._setObj("filter", "vc-filter vc-grid-2col float-box");
            obj.stateFilter = me._setObj("", "vc-grid-4col-menu vc-grid-margin-right float-box");

            // column 1: new & in process (internal)
            obj.stateFilterTop = me._setObj("", "div-state-filter vc-grid-1col-menu float");
            obj.chkShowNew = me._setInput("chk-show-new", "state-filter").prop("type", "checkbox").css("margin-right", "3px").prop("checked", "checked");
            obj.stateFilterTop.append(obj.chkShowNew, $("<label>").attr("for", "chk-show-new").text(" " + me.specific.resources.newEntries));
            obj.chkShowInProcess = me._setInput("chk-show-process", "state-filter").prop("type", "checkbox").css("margin-right", "3px").prop("checked", "checked");
            obj.stateFilterTop.append($("<br>"), obj.chkShowInProcess, $("<label>").attr("for", "chk-show-process").text(me.specific.resources.inProcess + "(" + me.specific.resources.internal + ")"));
            obj.stateFilter.append(obj.stateFilterTop);

            // column 2: in validation & in pause
            obj.stateFilterBottom = me._setObj("", "div-state-filter vc-grid-1col-menu float").css("margin-right", "-2px");
            obj.chkShowInValidation = me._setInput("chk-show-validation", "state-filter").prop("type", "checkbox").css("margin-right", "3px").prop("checked", "checked");
            obj.stateFilterBottom.append(obj.chkShowInValidation, $("<label>").attr("for", "chk-show-validation").text(" " + me.specific.resources.validation));
            obj.chkShowInPause = me._setInput("chk-show-pause", "state-filter").prop("type", "checkbox").css("margin-right", "3px").prop("checked", "checked");
            obj.stateFilterBottom.append($("<br>"), obj.chkShowInPause, $("<label>").attr("for", "chk-show-pause").text(me.specific.resources.inPause));
            obj.stateFilter.append(obj.stateFilterBottom);

            // column 3: permanent & in process (external)
            obj.stateFilterPermanent = me._setObj("", "div-state-filter vc-grid-1col-menu float").css("margin-right", "-2px");
            obj.chkShowPermanent = me._setInput("chk-show-permanent", "state-filter").prop("type", "checkbox").css("margin-right", "3px").prop("checked", "checked");
            obj.stateFilterPermanent.append(obj.chkShowPermanent, $("<label>").attr("for", "chk-show-permanent").text(" " + me.specific.resources.permanent));
            obj.chkShowProcessExt = me._setInput("chk-show-process-ext", "state-filter").prop("type", "checkbox").css("margin-right", "3px").prop("checked", "checked");
            obj.stateFilterPermanent.append($("<br>"), obj.chkShowProcessExt, $("<label>").attr("for", "chk-show-process-ext").text(me.specific.resources.inProcess + "(" + me.specific.resources.external + ")"));
            obj.stateFilter.append(obj.stateFilterPermanent);

            // column 4: not billable & show done
            obj.stateFilterCol4 = me._setObj("", "div-state-filter vc-grid-1col float").css("margin-right", "-2px");
            obj.chkShowNonBillable = me._setInput("chk-show-non-billable", "state-filter").prop("type", "checkbox").css("margin-right", "3px").prop("checked", "checked");
            obj.stateFilterCol4.append(obj.chkShowNonBillable, $("<label>").attr("for", "chk-show-non-billable").text(" " + me.specific.resources.notBillable));

            // show done
            obj.divShowDone = $("<div>").attr("id", "div-show-done").css("margin-top", "4px").hide();
            obj.chkShowDone = me._setInput("chk-show-done", "state-filter").prop("type", "checkbox").css("margin-right", "3px").prop("checked", false);
            obj.divShowDone.append(obj.chkShowDone, $("<label>").attr("for", "chk-show-done").text(" " + me.specific.resources.done));
            obj.stateFilterCol4.append(obj.divShowDone);

            obj.stateFilter.append(obj.stateFilterCol4);

            obj.entryCounter = me._setObj("div-entry counter", "div-state-filter vc-grid-2col float-box").html("");
            obj.wrapper.append(obj.filter, obj.stateFilter, obj.entryCounter);
            me.myRoot.append(obj.wrapper);

            // set width of state filter
            me._syncStateFilterWidth();

            //list area with list header
            obj = me.myHtml.list;
            obj.wrapper = me._setObj("lst-entries", "vc-list");
            obj.header = me._setListHeader("");
            // generate header list
            var line = me._setListItem();
            //add sort icons
            var divSort = $("<div>", {class:'div-sort'}).append($("<i>", {class:'sort-icon fa fa-sort inactive'}), $("<i>", {class:'sort-icon fa fa-arrow-up asc inactive'}), $("<i>", {class:'sort-icon fa fa-arrow-down desc active'}));
            var divSort1 = $("<div>", {class:'div-sort'}).append($("<i>", {class:'sort-icon fa fa-sort active'}), $("<i>", {class:'sort-icon fa fa-arrow-up asc inactive'}), $("<i>", {class:'sort-icon fa fa-arrow-down desc inactive'}));
            if (me.settings.parameter.Simple === true) {
                divSort.hide();
                divSort1.hide();
            }

            line.column.append(me._setListElement("", "col0 sort").data("sortid", 0).html(divSort).append($("<span>").html("Nr")));
            line.column.append(me._setListElement("", "col00 sort").data("sortid", 2).html(divSort1.clone()).append($("<span>").html(me.specific.resources.state)));
            line.column.append(me._setListElement("", "col3").html(me.specific.resources.start));
            line.column.append(me._setListElement("", "col4 sort").data("sortid", 5).html(divSort1.clone()).append($("<span>").html(me.specific.resources.completition)));
            line.column.append(me._setListElement("", "col1 ").html(me.specific.resources.name));
            line.column.append(me._setListElement("", "col2 sort  not-simple").data("sortid", 1).html(divSort1.clone()).append($("<span>").html(me.specific.resources.area)));
            line.column.append(me._setListElement("", "col5 not-simple").html(me.specific.resources.users));
            line.column.append(me._setListElement("", "col6").html("<br/>"));

            obj.header.append(line.item);

            obj.entries = me._setObj("entries", "vc-list-table");
            obj.wrapper.append(obj.header, obj.entries);

            //hide the top menu and sub menu if the simple parameter is set to true
            if (me.settings.parameter.Simple === true) {
                me.myHtml.topMenu.wrapper.hide();
                me.myHtml.subMenu.wrapper.hide();
                me.myHtml.filterMenu.wrapper.hide();
                obj.wrapper.find(".not-simple").hide();
              
            };





            me.myRoot.append(obj.wrapper);



            if (me.specific.readOnlyMode || !me.specific.hasEditRight) {
                me.myHtml.topMenu.wrapper.hide().height(0);
                me.myHtml.topMenu.projectFilterBox.hide().height(0);
                me.myHtml.topMenu.userFilterBox.hide().height(0);
                me.myHtml.subMenu.btnNew.hide();
                me.myHtml.subMenu.btnShowAllMyOpenEntries.hide();
                me.myHtml.subMenu.btnShowMyWatchlist.hide();
                me.myHtml.subMenu.btnShowAllMyEntries.hide();

                if (me.myHtml.subMenu.btnShowCustomerRequests) {
                    me.myHtml.subMenu.btnShowCustomerRequests.hide();
                }

                //in readonly mode we do not use a date filter - so we set a specific filter id for filtering everything
                me.myHtml.subMenu.btnShowAllEntries.data("filterid", 5);

            }





        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _initEvents: function () {
        var me = this;
        try {

            //add event handler for closing the ticket entry
            _VCMQ.addConsumer('local');
            _VCMQ.consume($("<div>"), 'local', function (e) { me._doEvents(e); });


            me.myHtml.topMenu.projectFilterBox.vcOptionBox({
                caption: me.resources.selection,
                items: [{ button: me.specific.resources.projects, clickable: false, isList: false, content: me.myHtml.topMenu.ddlProjectFilter }]
            });

            //inits first the project filter and then the vcDate box
            me._initProjectFilter();

            me.myHtml.topMenu.userFilterBox.vcOptionBox({
                caption: me.resources.selection,
                items: [{ button: me.specific.resources.users, clickable: false, isList: false, content: me.myHtml.topMenu.ddlUserFilter }]
            });

            me._initUserFilter();

            //click handler for filter menu
            me.myHtml.subMenu.wrapper.find(".button-toggle").off("click").on("click", function () {
                me.myHtml.subMenu.wrapper.find(".button-toggle").removeClass("button-toggle-active");
                $(this).addClass("button-toggle-active");
                me.fs.FilterId = parseInt($(this).data("filterid"));
                if (me.fs.FilterId >= 3) {
                    me.myHtml.topMenu.date.removeClass("disabled");
                } else {
                    me.myHtml.topMenu.date.removeClass("disabled").addClass("disabled");
                }

                // filter for user only available for "not my" tickets
                if (me.fs.FilterId === 0 || me.fs.FilterId === 2 || me.fs.FilterId === 3) {
                    me.myHtml.topMenu.userFilterBox.removeClass("disabled").addClass("disabled");
                }
                else {
                    me.myHtml.topMenu.userFilterBox.removeClass("disabled");
                }

                // checkbox for showing done tickets only available for "show all customer requests" 
                if (me.fs.FilterId === 6) {
                    me.myHtml.filterMenu.divShowDone.show();
                } else {
                    me.myHtml.filterMenu.divShowDone.hide();
                }
                // -----------------------------------------------------------------------------------------

                me._fetch();
            }).button();

            //click handler for sort icon
            me.myHtml.list.header.find(".sort").off("click").on("click", function () { me._sort($(this)); });

            me.myHtml.subMenu.btnNew.off("click").on("click", function () {
                me._showEntry($("<div>").data("id", -1));
            }).button();

            me.visual.find("#entries", ".vc-list-item").off("click", ".vc-list-item").on("click", ".vc-list-item", function () { me._showEntry($(this)); });

            //click handler for switching project icon
            me.myHtml.list.entries.on("click", ".set-logger", function (e) {
                $("<div>").vcSetLogger({ blid: parseInt($(e.target).data("blid")) });
                e.stopPropagation();
            });

            me.myHtml.filterMenu.filter.vcFilter({callback: function () {me._filter();}});

            //state filter icons
            me.myHtml.filterMenu.stateFilter.find(".state-filter").off("click").on("click", function () { me._fillList() });


            // If an openTid is provided, adjust the filter to "show all entries" and set project filter
            // so the ticket is guaranteed to be visible in the list
            if (me.specific.openTid > 0 && me.specific.openTidBlid > 0) {
                me._openTidPending = true;

                // set project filter to the ticket's project
                var pf = me.myHtml.topMenu.ddlProjectFilter;
                if (typeof (pf[0]) !== "undefined" && typeof (pf[0].selectize) !== "undefined") {
                    pf[0].selectize.setValue(me.specific.openTidBlid, true);
                }
                me.specific.filter_blid = me.specific.openTidBlid;

                // activate "show all entries" filter button (FilterId 4) to include closed/done tickets
                me.myHtml.subMenu.wrapper.find(".button-toggle").removeClass("button-toggle-active");
                me.myHtml.subMenu.btnShowAllEntries.addClass("button-toggle-active");
                me.fs.FilterId = parseInt(me.myHtml.subMenu.btnShowAllEntries.data("filterid"));
                me.myHtml.topMenu.date.removeClass("disabled");

                me.myHtml.filterMenu.divShowDone.hide();

            } else {
                // Set FilterId=1 and correct visual state directly (without using .trigger("click")),
                // because triggering the click handler would call _fetch() immediately, which can fail
                // with "cannot call methods on vcDateBox prior to initialization" when the widget is
                // re-created and the vcDateBox has not finished initializing yet.
                // The initial fetch is triggered later via the vcDateBox callback once it is ready.
                me.myHtml.subMenu.wrapper.find(".button-toggle").removeClass("button-toggle-active");
                me.myHtml.subMenu.btnShowAllOpenEntries.addClass("button-toggle-active");
                me.fs.FilterId = parseInt(me.myHtml.subMenu.btnShowAllOpenEntries.data("filterid"));
                me.myHtml.topMenu.date.removeClass("disabled").addClass("disabled");
                me.myHtml.topMenu.userFilterBox.removeClass("disabled").addClass("disabled");
                me.myHtml.filterMenu.divShowDone.hide();
            }


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _doEvents: function (e) {
        /// <summary>
        /// This function handles the ticket changed event from the ticket popup
        /// </summary>
        var me = this;
        try {
            switch (e.msg) {
                case "TICKETS_CHANGED": me._fetch(); break;
                default: break;
            }
        } catch (e) { me._writeErr(e); }
    },
    _initProjectFilter: function () {
        /// <summary>
        /// This function fills the project dropdown and inits the click handler
        /// </summary>
        var me = this;

        try {
            if (me.error) { return false;}
            
            me.myHtml.topMenu.ddlProjectFilter.selectize({
                create: false,
                maxItems: 1,
                valueField: 'Id',
                labelField: 'Name',
                searchField: 'Name',
                options: JSON.parse(me.specific.loggers),
                dropdownParent: 'body',

                render: {
                    option: function (item, escape) {
                        var sTmp = "<div class='option '>";
                        if (item.Icon.length > 0) {
                            sTmp += "<i class='fa " + item.Icon + "'></i> ";
                        }
                        sTmp += escape(item.Name) + "</div>";
                        return sTmp;
                    }
                },
                onChange: function () {
                    if (me.allFiltersInitialized) { me._fetch(); }
                },
                onInitialize: function () {
                    // if openTid is pending, set project filter to ticket's blid
                    if (me._openTidPending && me.specific.openTidBlid > 0) {
                        this.setValue(me.specific.openTidBlid, true);
                    } else if (me.specific.filter_blid > -1) {
                        this.setValue(me.specific.filter_blid);
                    }
                    //when we are finished we init the vcDate
                    me._initDate();
                }
            });
            return true;
        } catch (e) { me._writeErr(e); return false } 

    },
    _initUserFilter: function () {
        /// <summary>
        /// This function fills the user dropdown and inits the click handler
        /// </summary>
        var me = this;

        try {
            if (me.error) { return false; }

            me.myHtml.topMenu.ddlUserFilter.selectize({
                create: false,
                maxItems: 1,
                valueField: 'Id',
                labelField: 'Name',
                searchField: 'Name',
                options: JSON.parse(me.specific.ddlUsers),
                dropdownParent: 'body',

                render: {
                    option: function (item, escape) {
                        var sTmp = "<div class='option '>";
                        if (item.Icon.length > 0) {
                            sTmp += "<i class='fa " + item.Icon + "'></i> ";
                        }
                        sTmp += escape(item.Name) + "</div>";
                        return sTmp;
                    }
                },
                onChange: function () {
                    if (me.allFiltersInitialized) { me._fetch(); }
                },
                onInitialize: function () {
                    //when we are finished we init the vcDate
                    me._initDate();
                }
            });
            return true;
        } catch (e) { me._writeErr(e); return false }

    },
    _initDate: function () {
        /// <summary>
        /// This function inits the menu click handler. 
        /// </summary>
        var me = this;
        try {

            if (me.error) { return false; }
            me.myHtml.topMenu.date.vcDateBox(
                {
                    defaultRange: { from: me.specific.startDate, to: me.specific.endDate }, align: "right", mode: "Range", interval: 1, langID: me.settings.userLangIDForCulture,
                    callback: function () {
                        if (me.allFiltersInitialized) {
                            me._fetch();
                        } else {
                            // vcDateBox is now fully initialized - safe to call getDateRange() from _fetch()
                            me.allFiltersInitialized = true;
                            me._fetch();
                        }
                    }
                }
            );
            return true;
        } catch (e) { me._writeErr(e); return false }
    },
    _fetch: function () {
        var me = this;
        try {
            if (me.error) { return false; }

            // Capture a fetch token at call time - discards stale responses from previous sessions
            var fetchToken = (me._fetchToken = (me._fetchToken || 0) + 1);

            me.myHtml.list.entries.html(me.getLoadingIcon());

            //in readOnlyMode we show all entries without date filtering
            if (!me.specific.readOnlyMode && me.specific.hasEditRight) {

                // vcDateBox might not be initialized yet (e.g. when the widget is re-created and
                // the selectize onInitialize callbacks have not finished yet) - in that case init it now
                if (typeof (me.myHtml.topMenu.date.data("bluaul-vcDateBox")) === "undefined") {
                    me._initDate();
                }

                var dateRange = me.myHtml.topMenu.date.vcDateBox("getDateRange");
                me.fs.StartDate = dateRange.from;
                me.fs.EndDate = dateRange.to;
            }

            //get the currently selected project (blid)
            var pf = me.myHtml.topMenu.ddlProjectFilter;
            if (typeof (pf[0]) !== "undefined") {
                me.fs.Blid = typeof (pf[0].selectize) !== "undefined" ? pf[0].selectize.getValue() : -1;
            } else {
                me.fs.Blid = -1;
            }
            if (me.fs.Blid.length === 0) { me.fs.Blid = -1 }
            me.specific.filter_blid = me.fs.Blid;

            var uf = me.myHtml.topMenu.ddlUserFilter;
            if (typeof (uf[0]) !== "undefined") {
                me.fs.Uid = typeof (uf[0].selectize) !== "undefined" ? uf[0].selectize.getValue() : -1;
            } else {
                me.fs.Uid = -1;
            }
            if (me.fs.Uid.length === 0 || me.fs.FilterId === 0 || me.fs.FilterId === 2 || me.fs.FilterId === 3) { me.fs.Uid = -1 }

            if (me.specific.filter_bluid >= 0) { me.fs.Bluid = me.specific.filter_bluid }

            var param = { "typeid": 1, fs: me.fs }
            me.getData(param,
                function (result) {
                    // Discard stale responses from a previous fetch cycle (e.g. FilterId=5 arriving after re-open)
                    if (fetchToken !== me._fetchToken) { return; }

                    if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }
                    me.myData = result;
                    me._fillList();

                    // after the list is filled, check if we need to open a ticket automatically
                    me._handleOpenTid();

                    return true;
                });
            return true;
        } catch (e) { me._writeErr(e); return false }
    },
    _handleOpenTid: function () {
        /// <summary>
        /// This function opens a ticket automatically if openTid was provided as start parameter.
        /// It is called once after the first successful fetch. The ticket dialog is opened via
        /// showSingleTicketDialog which creates a modal popup with blurred background.
        /// </summary>
        var me = this;
        try {
            if (!me._openTidPending) { return; }
            me._openTidPending = false;

            var openTid = parseInt(me.specific.openTid);
            var openTidBlid = parseInt(me.specific.openTidBlid);
            if (isNaN(openTid) || openTid <= 0 || isNaN(openTidBlid) || openTidBlid <= 0) { return; }

            // determine readOnly state for the ticket
            var bReadOnly = me.specific.readOnlyMode;
            if (!bReadOnly) {
                if (me.specific.isStaff === "true") {
                    bReadOnly = false;
                } else if (me.specific.hasEditRight) {
                    // try to find the ticket in the loaded list to check priority
                    var foundEntry = null;
                    for (var i = 0; i < me.myData.length; i++) {
                        if (me.myData[i].Id === openTid) {
                            foundEntry = me.myData[i];
                            break;
                        }
                    }
                    if (foundEntry) {
                        bReadOnly = (parseInt(foundEntry.Data.Priority) !== 6);
                    } else {
                        // ticket not in list - let the Ticket widget handle permissions server-side
                        bReadOnly = false;
                    }
                } else {
                    bReadOnly = true;
                }
            }

            // open the ticket dialog (modal with blur overlay, same as normal click)
            me.vcV.showSingleTicketDialog(openTidBlid, { "TicketID": openTid, LoggerID: openTidBlid, readOnlyMode: bReadOnly });

        } catch (e) { me._writeErr(e); }
    },
    _fillList: function () {
        /// <summary>
        ///  This function generates a vc-list based on the given entries. 
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false;}
       
            me.myHtml.list.entries.html("");
            $.each(me.myData, function (key, row) {
                if (row.Id > 0) me.myHtml.list.entries.append(me._fillRow(row));
            });

            me._filter();
            return true;
        } catch (e) { me._writeErr(e); return false }

    },
    _fillRow: function (entry) {
        /// <summary>
        ///  This function generates a vc-list based entry on the given entries. 
        /// </summary>
        var me = this;
        var item;
        var col;
        var myTodo;
        var bOwner;
        try {
            if (me.error) { return false;}

            //let's see if it's something to do for me
            myTodo = me._getMyTodoState(entry);
           
            //let's see if I'm the owner
            bOwner = false;
            var ownerid = me._getUserID(entry, me.specific.USER_OWNER_TYPEID);
            if (ownerid.length > 0) {
                ownerid = parseInt(ownerid);
                if (me.uid === ownerid) { bOwner = true; }
            }

            item = $("<li>").addClass("vc-list-item").data("id", entry.Id);

            if (entry.Done) {
                item.addClass("state-done");
            }
            col = $("<div>").addClass("vc-list-col");

            var el0 = $("<div>").addClass("vc-list-col-element col0");

            if (entry.Done) {
                var icon = $("<div>").addClass("fa-stack");
                icon.append($("<i>").addClass("fa fa-check icon-done icon-color-ok fa-stack-2x"));
                icon.append($("<i>").addClass(entry.Infos.TypeIcon + " icon-ticket fa-stack-1x"));
                icon.attr("title", entry.Data.EndDate);
                el0.append(icon);
            } else {
                el0.append($("<i>").addClass(entry.Infos.TypeIcon + " icon-ticket"));
            }

            el0.append($("<i>").addClass(entry.Infos.TaskIcon + " icon-type").attr("title", entry.Infos.Task));
            var ticket = $("<div>").addClass("infos").html("Nr: " + entry.Id + "<br/>");

            if (bOwner) { el0.addClass("color-font-secondary"); }


            el0.append(ticket);

            ticket.append($("<i>").addClass(entry.Infos.PriorityIcon).attr("title", entry.Infos.Priority));
            if (entry.Data.Notify) {
                ticket.append($("<i>").addClass("fa fa-envelope").attr("title", "send email"));
            }
            if (entry.Data.Scope === 1) {
                ticket.append($("<i>").addClass("fa fa-users").attr("title", "internal only"));
            }
            el0.append(ticket);


            col.append(el0);

            var el00 = $("<div>").addClass("vc-list-col-element col00")
                .html($("<i>").addClass(entry.Infos.StatusIcon).attr("title", entry.Infos.Status));
            if (myTodo) { el00.addClass("myone"); }
            col.append(el00);

            var el3 = $("<div>").addClass("vc-list-col-element col3");
            el3.append($("<div>").addClass("minor").html(entry.Data.StartDate));
            if (myTodo) { el3.css("font-weight", "bold") }
            col.append(el3);

            var el4 = $("<div>").addClass("vc-list-col-element col4");
            var compDate = $("<span>").addClass("minor").html(entry.Data.CompletitionDate.length > 0 ? entry.Data.CompletitionDate : $("<br>"));
            if (!entry.Done) {
                var dt = window.moment(entry.Data.CompletitionDate, "DD.MM.YYYY");
                if (window.moment.duration(dt.diff(new Date)).asDays() < 0) {
                    compDate.css("background-color", "red");
                } else {
                    if (window.moment.duration(dt.diff(new Date)).asDays() < 3) {
                        compDate.css("background-color", "gold");

                    }
                }
            }
            col.append(el4.append(compDate));

            var el1 = $("<div>").addClass("vc-list-col-element col1");
            el1.append($("<div>").addClass("major").html(entry.Data.Name));
            col.append(el1);


            if (!me.settings.parameter.Simple) {

                var el2 = $("<div>").addClass("vc-list-col-element col2").html($("<i>", { 'data-blid': entry.Blid, "class": "set-logger fa fa-exchange-alt icon-color-ok" }));
                el2.append(" ");
                el2.append(me._getAssignment(entry));
                col.append(el2);


                var el5 = $("<div>").addClass("vc-list-col-element col5");
                el5.append($("<div>").addClass("part").html(me._getUser(entry, me.specific.USER_EXECUTOR_TYPEID)));
                el5.append($("<div>").addClass("spacer").html(""));
                el5.append($("<div>").addClass("part").html(me._getUser(entry, me.specific.USER_VALIDATOR_TYPEID)));
                col.append(el5);

                var el6 = $("<div>").addClass("vc-list-col-element col6");

                el6.append($("<div>").addClass("done").html(me._getWatchlistState(entry)));
                col.append(el6);
            }
            item.append(col);
            return item;
        } catch (e) { me._writeErr(e); return false; }

    },
    _filter: function () {
        /// <summary>
        /// This function takes all tags from the vcFilter widget (filterObj) and adds a 'classFound' css class to all entries it founds in 'listItem'.<br/>
        /// It is used as part of the filter function in vc-lists
        /// </summary>
        var me = this;
        try {

            if (me.error) {return false; }

            this._doListTableFilter(this.myHtml.list.entries);

            if (!me.myHtml.filterMenu.chkShowNew.is(":checked")) {
                me.myHtml.list.entries.find(".col00 .fa-plus").each(function () {
                    $(this).parents(".vc-list-item").removeClass("found").hide();
                });
            }
            if (!me.myHtml.filterMenu.chkShowInProcess.is(":checked")) {
                me.myHtml.list.entries.find(".col00 .fa-screwdriver").each(function () {
                    $(this).parents(".vc-list-item").removeClass("found").hide();
                });
            }
            if (!me.myHtml.filterMenu.chkShowInValidation.is(":checked")) {
                me.myHtml.list.entries.find(".col00 .fa-stethoscope").each(function () {
                    $(this).parents(".vc-list-item").removeClass("found").hide();
                });
            }
            if (!me.myHtml.filterMenu.chkShowInPause.is(":checked")) {
                me.myHtml.list.entries.find(".col00 .fa-pause").each(function () {
                    $(this).parents(".vc-list-item").removeClass("found").hide();
                });
            }

            if (!me.myHtml.filterMenu.chkShowPermanent.is(":checked")) {
                me.myHtml.list.entries.find(".col00 .fa-infinity").each(function () {
                    $(this).parents(".vc-list-item").removeClass("found").hide();
                });
            }

            if (!me.myHtml.filterMenu.chkShowProcessExt.is(":checked")) {
                me.myHtml.list.entries.find(".col00 .fa-user-tag, .col00 .fa-light.fa-user-tag").each(function () {
                    $(this).parents(".vc-list-item").removeClass("found").hide();
                });
            }

            if (!me.myHtml.filterMenu.chkShowNonBillable.is(":checked")) {
                me.myHtml.list.entries.find(".col00 .fa-times-circle").each(function () {
                    $(this).parents(".vc-list-item").removeClass("found").hide();
                });
            }

            if (me.fs.FilterId === 6 && !me.myHtml.filterMenu.chkShowDone.is(":checked")) {
                me.myHtml.list.entries.find(".vc-list-item.state-done").removeClass("found").hide();
            }

            me.myHtml.list.entries.find(".vc-list-item ").removeClass("alt");
            me.myHtml.list.entries.find(".vc-list-item.found:even").addClass("alt");

            me.myHtml.filterMenu.entryCounter.html(me.myHtml.list.entries.find(".vc-list-item.found:visible").length + " " + me.specific.resources.entriesFound);
            return true;
        } catch (e) { me._writeErr(e); return false; }
    },
    _showEntry: function (obj) {
        /// <summary>
        ///  This function shows one single entry as popup
        /// </summary>
        var me = this;
        //var entry = null;
        var id;
        var i;
        var bAdd = false;
        try {
            if (me.error) { return false;}

            bReadOnly = me.specific.readOnlyMode;
         

            //get entry id
            id = parseInt(obj.data("id"));
            me.entry = null;
            var startEntry = null;

            //if we got a new entry
            if (id === -1) {

                //get default settings for a ticket entry
                me.entry = JSON.parse(me.specific.tplTicket);
                //set the currently selected project
                me.entry.Blid = me.specific.filter_blid;
               
                //get the set start entry from the visual parameters
                var start = JSON.parse(me.specific.startEntry);

                if (start == null) {
                   
                    
                    // if non staff user has edit right, he can create a new ticket with default settings (priority 6, taskid 2)
                    if (me.specific.isStaff == "false" && me.specific.hasEditRight) {

                        startEntry = {
                            Blid: me.settings.blid, Assignments: { Assignments: [] },
                            Data: { Priority: 6 }
                        };

                    }
                    else {
                        // if we set a single bsaid as filter, we start a new ticket with this signal selected (deprecated)
                        if (me.specific.filter_bsaid !== -1) {
                            startEntry = { Assignments: { Assignments: [{ TypeId: 2, AssId: me.specific.filter_bsaid }], AssignmentTypes: { Bluid: -1, Blhid: -1 } } }
                        }
                    }                  

                } else {

                    //set the specific start entry
                    startEntry = start;


                    // for non-staff users with edit right (customer users): Priority and TaskID must always be forced to 6 / 2, regardless of what the startEntry provides.
                    // Assignments are kept as-is from the passed startEntry.
                    if (me.specific.isStaff == "false" && me.specific.hasEditRight) {
                        startEntry.Data.Priority = 6;
                    }
                }

            } else {

                //find the current entry from the entry list
                for (i = 0; i < me.myData.length; i++) {
                    if (me.myData[i].Id === id) {

                        // only evaluate edit rights if readOnlyMode was not explicitly forced by the caller
                        if (!me.specific.readOnlyMode) {

                            // Staff can edit all tickets
                            if (me.specific.isStaff == "true") {
                                bReadOnly = false;
                            } else if (me.specific.hasEditRight) {
                                // non-staff users with hasEditRight may only edit tickets with priority 6 (customer request)
                                bReadOnly = (parseInt(me.myData[i].Data.Priority) !== 6);
                            } else {
                                bReadOnly = true;
                            }
                        }

                        me.entry = me.myData[i];
                        break;
                    }
                }
            }
            if (me.entry === null) {me.showMessage(me.resources.noEntriesExist, true);return false;}

            me.vcV.showSingleTicketDialog(me.entry.Blid, { "TicketID": id, LoggerID: me.entry.Blid, readOnlyMode: bReadOnly, startEntry: startEntry });

            return true;
        } catch (e) { me._writeErr(e); return false; }

    },
    _getAssignment: function (entry) {
        /// <summary>
        ///  This function generates list with assignments for a single entry
        /// </summary>
        var me = this;
        var hw = "";
        try {
            if (me.error) {
                return false;
            }
            var assign = $("<div>");

            assign.append($("<div>").addClass("part").html(entry.Assignments.Project));
            assign.append($("<div>").addClass("spacer").html(""));
            if (entry.Assignments.Unit.length > 0) {
                if (entry.Assignments.Hardware.length > 0) {
                    hw = " / " + entry.Assignments.Hardware;
                }
                assign.append($("<div>").addClass("minor").html("(" + entry.Assignments.Unit + hw + ")"));
            }

            if (entry.Assignments.Signals.length > 0) {
                if (entry.Assignments.Signals[0].length > 0) {
                    assign.append($("<div>").addClass("minor")
                        .html("(" + entry.Assignments.Signals.length + " " + me.specific.resources.signals + ")"));
                }
            }


            return assign;
        } catch (e) { me._writeErr(e); return false; }

    },
    _getUser: function (entry, type) {
        /// <summary>
        ///  This function generates a vc-list based on the given entries. 
        /// </summary>
        var me = this;
        var bFound = false;
        var name;

        try {
            if (me.error) {
                return false;
            }
            var user = $("<div>");
            if (entry.Users.UserTypes !== null) {
                for (var j = 0; j < entry.Users.UserTypes.length; j++) {
                    if (parseInt(entry.Users.UserTypes[j]) === type) {
                        name = entry.Users.UserNames[j];
                        if (name.length > 0) {
                            user.html(name);
                            bFound = true;
                        }
                    }
                }
            }

            if (bFound === false) {

                if (type !== me.specific.USER_VALIDATOR_TYPEID) { user.html("user not found with type:" + type); }
            } else {
                if (type === me.specific.USER_EXECUTOR_TYPEID) {
                    user.prepend($("<i>").addClass("fa fa-briefcase icon-color-info"));
                    if (entry.Data.ExecutionTime.length > 0 || entry.Done) {
                        user.append($("<i>").addClass("fa fa-check icon-color-ok").attr("title", entry.Data.ExecutionTime));
                    } else {
                        user.addClass("active-state");
                    }
                }
                if (type === me.specific.USER_VALIDATOR_TYPEID) {
                    user.prepend($("<i>").addClass("fa fa-stethoscope icon-color-info"));
                    if (entry.Data.ValidationTime.length > 0) {
                        user.append($("<i>").addClass("fa fa-check icon-color-ok").attr("title", entry.Data.ValidationTime));
                    } else {
                        user.addClass("active-state");
                    }
                }
            }

            return user;
        } catch (e) { me._writeErr(e); return false; }

    },
    _getUserID: function (entry, type) {
        /// <summary>
        ///  This function returns a list of users for one single entry
        /// </summary>
        var me = this;

        var ids = [];
        try {
            if (me.error) {return ids;}

            if (entry.Users.Users !== null) {
                for (var j = 0; j < entry.Users.Users.length; j++) {
                    if (entry.Users.Users[j].TypeId === type) {ids.push(entry.Users.Users[j].Uid);}
                }
            }

            return ids;
        } catch (e) { me._writeErr(e); return -1; }
    },
    _getWatchlistState: function (entry) {
        /// <summary>
        ///  This function finds out if the current user is on the watchlist and returns an icon for that
        /// </summary>
        var me = this;
        var bInWatchlist = false;
        var bInUsers = false;
        try {
            if (me.error) {
                return false;
            }
            var user = $("<div>");
            if (entry.Users.Users !== null) {
                for (var j = 0; j < entry.Users.Users.length; j++) {
                    if (entry.Users.Users[j].Uid === me.uid) { bInUsers = true; }
                    if (parseInt(entry.Users.Users[j].TypeId) === me.specific.USER_WATCHLIST_TYPEID) {

                        //set the watchlist icon if the current user is on the watchlist
                        if (entry.Users.Users[j].Uid === me.uid) { bInWatchlist = true; }
                    }
                }
            }

            if (!bInUsers) {
                if (entry.Data.Uid === me.uid) {
                    bInUsers = true;
                }
            }

            if (bInWatchlist) {
                user.html($("<i>").data("id", entry.Id).data("set", true).addClass("icon-watchlist fas fa-eye  icon-color-ok"));
            } else {

                if (!bInUsers) {
                    user.html($("<i>").data("id", entry.Id).data("set", false).addClass("icon-watchlist  fas fa-eye  inactive"));
                } else {
                    user.html("<br/>");
                }

            }

            return user;
        } catch (e) { me._writeErr(e); return false; }

    },
    _getMyTodoState: function (entry) {
        /// <summary>
        ///  This function generates a vc-list based on the given entries. 
        /// </summary>
        var me = this;
        var uid;
        try {
            if (me.error) {  return false;}
            if (entry.Done) { return false }

            uid = me._getUserID(entry, me.specific.USER_EXECUTOR_TYPEID);
           
            if (uid.length > 0) { uid = parseInt(uid); }
            if (entry.Data.ExecutionTime.length === 0) {
                return (me.specific.uid === uid);
            }

            uid = me._getUserID(entry, me.specific.USER_VALIDATOR_TYPEID);

            if (uid.length > 0) { uid = parseInt(uid); }
            if (me.specific.uid === uid) {
                if (entry.Data.ValidationTime.length === 0) { return true; }
            }
            return false;

        } catch (e) { me._writeErr(e); return false; }
    },
    _sort: function (obj) {
        /// <summary>
        ///  This function resorts the list ;-)
        /// </summary>
        var me = this;
        var id;
        var type;
        try {
            if (me.error) {return false;}

            me.fnd(".sort-icon").hide();
            me.fnd(".fa-sort").show();
            obj.find(".fa-sort").hide();
            id = parseInt(obj.data("sortid"));
            if (obj.find(".fa-sort").hasClass("inactive") === false) {

                obj.find(".fa-sort").addClass("inactive").hide();
                obj.find(".asc").removeClass("inactive").addClass("active").show();
                me.fs.SortType = "asc";
            } else {

                type = obj.find(".sort-icon.active");
                if (type.hasClass("desc")) {
                    me.fs.SortType = "asc";
                    obj.find(".sort-icon.asc").removeClass("inactive").addClass("active").show();
                } else {
                    me.fs.SortType = "desc";
                    obj.find(".sort-icon.desc").removeClass("inactive").addClass("active").show();
                }
                type.hide().removeClass("active").addClass("inactive");
            }
            me.fs.SortId = id;
            me._fetch();

            return true;
        } catch (e) { me._writeErr(e); return false; }

    },
    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            let hList = me._getVisualHeight();
            if (!me.settings.parameter.Simple) hList = hList - me.myHtml.topMenu.wrapper.outerHeight() - me.myHtml.subMenu.wrapper.outerHeight() - me.myHtml.filterMenu.wrapper.outerHeight() - me.myHtml.list.header.outerHeight() - 7;
          
          
            //console.info(me.myHtml.topMenu.wrapper.outerHeight());
            //console.info(me.myHtml.subMenu.wrapper.outerHeight());
            //console.info(me.myHtml.filterMenu.wrapper.outerHeight());
            //console.info(me.myHtml.list.header.outerHeight());


            //console.info(hList);

            me.myHtml.list.wrapper.css("height", hList);
            hList = hList - me.myHtml.list.header.outerHeight();
            me.myHtml.list.entries.css("max-height", hList -24);

            me.myHtml.subMenu.menu.width(parseInt(me.myRoot.width()));

            // set width of state filter
            me._syncStateFilterWidth();

        } catch (e) { me._writeErr(e); return false; }
        return true;     
    },

    _syncStateFilterWidth: function () {
        /// <summary>
        /// ensures stateFilter is wide enough so the two div-state-filter columns stay side-by-side
        /// </summary>
        var me = this;
        try {
            var fm = me.myHtml.filterMenu;
            if (!fm || !fm.stateFilter || fm.stateFilter.length === 0) return;
            if (!fm.stateFilterTop || fm.stateFilterTop.length === 0) return;
            if (!fm.stateFilterBottom || fm.stateFilterBottom.length === 0) return;
            if (!fm.stateFilterPermanent || fm.stateFilterPermanent.length === 0) return;

            // default: 3 columns
            fm.stateFilter.removeClass("vc-grid-2col").addClass("vc-grid-3col");

            var topEl = fm.stateFilterTop.get(0);
            var permEl = fm.stateFilterPermanent.get(0);
            if (!topEl || !permEl) return;

            var topTop = topEl.getBoundingClientRect().top;
            var permTop = permEl.getBoundingClientRect().top;

            // if 3rd column wraps -> fall back to 2 columns
            if (permTop > topTop + 0.5) {
                fm.stateFilter.removeClass("vc-grid-3col").addClass("vc-grid-2col");
            }

        } catch (e) { me._writeErr(e); }
    },




    specificInfoHandling: function (bError) {
        /// <summary>
        /// This function calls hides the content on error state.
        /// </summary>
        var me = this;
        try {
            if (bError) {
                me.myHtml.topMenu.hide();
                me.myHtml.subMenu.hide();
                me.myHtml.filterMenu.hide();
                me.myHtml.list.hide();
            }
            return true;
        } catch (e) { me._writeErr(e); return false }
    },
  

    ////TODO: remove writeError
    //_writeErr: function (ex) {
       
    //        console.error(ex);
    //    //this._writeErr(ex);
    //    },

});
